import React from "react";
import { CancelToken } from "axios";

import { GetVendor } from "api/rpc/2024-04/facilityAdmin/product/vendor";
import VendorList from "pages/secure/vendors/VendorList";

export default function Vendors() {
  return (
    <VendorList
      listPath="/admin/settings/vendors"
      newPath="/admin/settings/vendors/new"
      editPath={id => "/admin/settings/vendors/" + String(id)}
      load={(token?: CancelToken) => GetVendor({}, false, token)}
    />
  );
}
